/**
 * ECharts安全加载工具
 * 避免服务器端渲染时出现"window is not defined"错误
 */

// 用于在服务器端渲染时提供一个虚拟的ECharts对象
export const mockECharts = {
  init: () => ({
    setOption: () => {},
    resize: () => {},
    dispose: () => {},
    on: () => {},
  }),
  graphic: {
    LinearGradient: function () {
      return {};
    },
  },
};

// 懒加载ECharts，仅在客户端环境中使用
export const loadECharts = async () => {
  if (typeof window !== 'undefined') {
    return await import('echarts');
  }
  return mockECharts;
};

// 获取ECharts实例，安全地在SSR环境中使用
export const getECharts = () => {
  if (typeof window !== 'undefined') {
    try {
      return require('echarts');
    } catch (e) {
      return mockECharts;
    }
  }
  return mockECharts;
};
